import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  InputNumber,
  Button,
  Spin,
  Row,
  Col,
  Popover,
  // Slider,
  Select,
} from "antd";
import { ReactSVG } from "react-svg";
import { isEmpty, sample } from "lodash";
import { useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

import "./Driver.scss";
import AddressInput from "../../Inputs/AddressInput";
import TimeInput from "../../Inputs/TimeInput";
import InfoLabel from "../../Elements/InfoLabel";
import { COLORS } from "../../../constants";
import { getTranslation, setCountryCookie } from "../../../utils/helper";
import TagInput from "../../Elements/TagInput";

const DriverForm = ({ form, isFetching, driver, handleSubmit, handleCancel, countryCodeInit }) => {
  const user = useSelector(state => state.auth.user);
  const setting = user.company;

  const [countryPhone, setCountryPhone] = useState();
  const [state, setState] = useState({
    visiblePopover: false,
    color: "",
    skills: [],
  });

  // const speeds = {
  //   0: getTranslation(setting, "Drivers", "X2 Slower"),
  //   15: getTranslation(setting, "Drivers", "Slower"),
  //   30: getTranslation(setting, "Drivers", "Slow"),
  //   50: getTranslation(setting, "Drivers", "Normal"),
  //   70: getTranslation(setting, "Drivers", "Fast"),
  //   85: getTranslation(setting, "Drivers", "Faster"),
  //   100: getTranslation(setting, "Drivers", "X2 Faster"),
  // };

  const speeds = [
    { value: 30, label: getTranslation(setting, "Drivers", "Slow") },
    { value: 50, label: getTranslation(setting, "Drivers", "Normal") },
    { value: 70, label: getTranslation(setting, "Drivers", "Fast") },
  ];

  const speedCodes = {
    30: "Slow",
    50: "Normal",
    70: "Fast",
  };

  useEffect(() => {
    setState({
      ...state,
      color: form.getFieldValue("color") || sample(COLORS),
      skills: form.getFieldValue("skills") || [],
    });
  }, [driver]);

  const handleSelectedColor = color => {
    setState({ ...state, visiblePopover: false, color });
  };

  const handleVisibleChange = visible => {
    setState({ ...state, visiblePopover: visible });
  };

  const handleChangeSkills = values => {
    setState({ ...state, skills: values });
  };

  const handleOnFinish = values => {
    const params = { ...values };
    params.color = state.color;
    params.skills = state.skills;
    params.phone =
      !isEmpty(values.phone) && countryPhone?.dialCode !== values.phone
        ? `${values.phone.includes("+") ? "" : "+"}${values.phone}`
        : null;
    params.speed = speedCodes[values["speed"]].replace(/\s/g, "").toUpperCase();
    handleSubmit(params);
  };

  const handleOnChangeShiftStart = value => {
    form.setFieldsValue({ shiftStart: value });
  };

  const checkValidateShiftStart = value => {
    let isValid = true;
    let message = "";
    const shiftEnd = form.getFieldValue("shiftEnd");
    if (isEmpty(value) || isEmpty(shiftEnd)) {
      return { isValid, message };
    }
    const shiftEndSplit = shiftEnd.split(":");
    const valueSplit = value.split(":");
    if (shiftEndSplit[0] < valueSplit[0] || (shiftEndSplit[0] === valueSplit[0] && shiftEndSplit[1] < valueSplit[1])) {
      isValid = false;
      message = "Shift Start must be less than Shift End";
    }
    return { isValid, message };
  };

  const handleOnChangeShiftEnd = value => {
    form.setFieldsValue({ shiftEnd: value });
  };

  const checkValidateShiftEnd = value => {
    let isValid = true;
    let message = "";
    const shiftStart = form.getFieldValue("shiftStart");
    if (isEmpty(value) || isEmpty(shiftStart)) {
      return { isValid, message };
    }
    const shiftStartSplit = shiftStart.split(":");
    const valueSplit = value.split(":");
    if (
      shiftStartSplit[0] > valueSplit[0] ||
      (shiftStartSplit[0] === valueSplit[0] && shiftStartSplit[1] > valueSplit[1])
    ) {
      isValid = false;
      message = "Shift End must be greater than Shift Start";
    }
    return { isValid, message };
  };

  const handleOnChangeBreakStart = value => {
    form.setFieldsValue({ breakStart: value });
  };

  const checkValidateBreakStart = value => {
    let isValid = true;
    let message = "";
    const breakEnd = form.getFieldValue("breakEnd");
    if (isEmpty(value) || isEmpty(breakEnd)) {
      return { isValid, message };
    }
    const shiftEndSplit = breakEnd.split(":");
    const valueSplit = value.split(":");
    if (shiftEndSplit[0] < valueSplit[0] || (shiftEndSplit[0] === valueSplit[0] && shiftEndSplit[1] < valueSplit[1])) {
      isValid = false;
      message = "Break Start must be less than Break End";
    }
    return { isValid, message };
  };

  const handleOnChangeBreakEnd = value => {
    form.setFieldsValue({ breakEnd: value });
  };

  const checkValidateBreakEnd = value => {
    let isValid = true;
    let message = "";
    const breakStart = form.getFieldValue("breakStart");
    if (isEmpty(value) || isEmpty(breakStart)) {
      return { isValid, message };
    }
    const shiftStartSplit = breakStart.split(":");
    const valueSplit = value.split(":");
    if (
      shiftStartSplit[0] > valueSplit[0] ||
      (shiftStartSplit[0] === valueSplit[0] && shiftStartSplit[1] > valueSplit[1])
    ) {
      isValid = false;
      message = "Break End must be greater than Break Start";
    }
    return { isValid, message };
  };

  return (
    <Spin spinning={isFetching}>
      <div className="DriverForm">
        <Form
          form={form}
          scrollToFirstError
          layout="vertical"
          hideRequiredMark
          colon={false}
          onFinish={handleOnFinish}
          onKeyPress={e => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          }}>
          <div className="FormHeader">
            <div className="left">
              {driver
                ? getTranslation(setting, "Drivers", "Edit Driver")
                : getTranslation(setting, "Drivers", "New Driver")}
            </div>
          </div>
          <div className="FormContent">
            <Row gutter={24}>
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <div className="DriverName">
                  <Form.Item
                    label={
                      <InfoLabel
                        text={getTranslation(setting, "Drivers", "Driver Name")}
                        title="The displayed name of your driver."
                        required={true}
                      />
                    }
                    name="name"
                    rules={[{ required: true, message: "Required" }]}
                    style={{
                      width: "100%",
                    }}>
                    <Input size="large" placeholder={getTranslation(setting, "Drivers", "Driver Name")} />
                  </Form.Item>
                  <Popover
                    content={
                      <div className="optionsColors">
                        {COLORS.map((color, index) => {
                          return (
                            <Button
                              className={`DriverColor ${color === state.color ? "selected" : ""}`}
                              key={index}
                              onClick={() => handleSelectedColor(color)}>
                              <span className="color" style={{ backgroundColor: `#${color}` }} />
                            </Button>
                          );
                        })}
                      </div>
                    }
                    trigger="click"
                    open={state.visiblePopover}
                    onOpenChange={handleVisibleChange}>
                    <Button size="large" className="DriverColor">
                      <span className="color" style={{ backgroundColor: `#${state.color}` }} />
                    </Button>
                  </Popover>
                </div>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <div className="item-label">
                  <div className="left">
                    <label>
                      <InfoLabel
                        text={getTranslation(setting, "Drivers", "Email")}
                        title="Your driver's email address."
                      />
                    </label>
                  </div>
                  <div className="right">Optional</div>
                </div>
                <Form.Item name="email" rules={[{ type: "email", message: "Invalid Email" }]}>
                  <Input size="large" placeholder={getTranslation(setting, "Drivers", "Email")} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col xs={{ span: 24 }} md={{ span: 8 }}>
                <Form.Item
                  label={
                    <InfoLabel
                      text={getTranslation(setting, "Drivers", "Phone Number")}
                      title="Your driver's phone number that includes the country code and plus sign e.g. +17789123456 for US/Canada numbers or +6593456789 for Singapore numbers."
                      required={true}
                    />
                  }
                  name="phone"
                  rules={[{ required: true, message: "Required" }]}>
                  <PhoneInput
                    country={countryCodeInit}
                    enableSearch
                    disableSearchIcon
                    onChange={(value, country) => {
                      setCountryPhone(country);
                      setCountryCookie(value, country, user);
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 4 }}>
                <Form.Item
                  label={
                    <InfoLabel
                      text={getTranslation(setting, "Drivers", "Capacity")}
                      title="How big your driver's vehicle is e.g. if it can carry 10 packages, use a capacity of 10. This will determine how many packages can fit into the vehicle."
                    />
                  }
                  name="capacity">
                  <InputNumber
                    size="large"
                    placeholder={getTranslation(setting, "Drivers", "Capacity")}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <Row gutter={24}>
                  <Col xs={{ span: 24 }} md={{ span: 12 }}>
                    <TimeInput
                      label={
                        <InfoLabel
                          text={getTranslation(setting, "Drivers", "Shift Start")}
                          title="The time at which your driver starts his route."
                        />
                      }
                      name="shiftStart"
                      required={false}
                      onChange={handleOnChangeShiftStart}
                      checkValidate={checkValidateShiftStart}
                      value={form.getFieldValue("shiftStart")}
                    />
                  </Col>
                  <Col xs={{ span: 24 }} md={{ span: 12 }}>
                    <TimeInput
                      label={
                        <InfoLabel
                          text={getTranslation(setting, "Drivers", "Shift End")}
                          title="The time at which your driver ends his route."
                        />
                      }
                      name="shiftEnd"
                      required={false}
                      onChange={handleOnChangeShiftEnd}
                      checkValidate={checkValidateShiftEnd}
                      value={form.getFieldValue("shiftEnd")}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 24 }}>
                <Row gutter={24}>
                  <Col xs={{ span: 24 }} md={{ span: 12 }}>
                    <TimeInput
                      label={<InfoLabel text={getTranslation(setting, "Drivers", "Break Start")} />}
                      name="breakStart"
                      required={false}
                      onChange={handleOnChangeBreakStart}
                      checkValidate={checkValidateBreakStart}
                      value={form.getFieldValue("breakStart")}
                    />
                  </Col>
                  <Col xs={{ span: 24 }} md={{ span: 12 }}>
                    <TimeInput
                      label={<InfoLabel text={getTranslation(setting, "Drivers", "Break End")} />}
                      name="breakEnd"
                      required={false}
                      onChange={handleOnChangeBreakEnd}
                      checkValidate={checkValidateBreakEnd}
                      value={form.getFieldValue("breakEnd")}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <Form.Item
                  label={
                    <InfoLabel
                      text={getTranslation(setting, "Drivers", "Start Location")}
                      title="Where your driver starts his route."
                      required={true}
                    />
                  }
                  name="startLocation"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (value?.address && value?.latLng?.lat && value?.latLng?.lng) {
                          return Promise.resolve();
                        }

                        if (isEmpty(value?.address)) {
                          return Promise.reject(new Error("Required"));
                        }

                        return Promise.reject(new Error("Invalid"));
                      },
                    },
                  ]}>
                  <AddressInput
                    size="large"
                    placeholder={getTranslation(setting, "Drivers", "Start Location")}
                    onSelect={value => form.setFieldsValue({ startLocation: value })}
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <div className="item-label">
                  <div className="left">
                    <label>
                      <InfoLabel
                        text={getTranslation(setting, "Drivers", "End Location")}
                        title="Where your driver ends his route."
                      />
                    </label>
                  </div>
                  <div className="right">Optional</div>
                </div>
                <Form.Item
                  name="endLocation"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (
                          !value ||
                          isEmpty(value?.address) ||
                          (value?.address && value?.latLng?.lat && value?.latLng?.lng)
                        ) {
                          return Promise.resolve();
                        }

                        return Promise.reject(new Error("Invalid"));
                      },
                    },
                  ]}>
                  <AddressInput
                    size="large"
                    placeholder={getTranslation(setting, "Drivers", "End Location")}
                    onSelect={value => form.setFieldsValue({ endLocation: value })}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <Form.Item
                  label={
                    <InfoLabel
                      text={getTranslation(setting, "Drivers", "Driver Skills")}
                      title="For advanced users only. Use this to match specific orders with drivers that are equipped to do those orders e.g. a VIP driver can pickup and deliver VIP orders."
                    />
                  }>
                  <TagInput tags={state.skills} onChange={handleChangeSkills} />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 12 }}>
                <Form.Item
                  name="speed"
                  label={
                    <InfoLabel
                      text={getTranslation(setting, "Drivers", "Speed")}
                      title="Use this parameter to specify the driver's speed"
                    />
                  }>
                  <Select size="large" placeholder="What best describes your company?">
                    {speeds.map(({ label, value }) => (
                      <Select.Option key={value} value={value}>
                        {label}
                      </Select.Option>
                    ))}
                  </Select>
                  {/* <Slider
                marks={speeds}
                included={false}
                step={null}
                defaultValue="50"
              /> */}
                </Form.Item>
              </Col>
            </Row>
          </div>
          <div className="FormFooter">
            <div className="Left"></div>
            <div className="Right">
              <Button key="cancel" onClick={handleCancel}>
                {getTranslation(setting, "Common", "Cancel")}
              </Button>
              <Button htmlType="submit" type="primary">
                {driver ? getTranslation(setting, "Common", "Update") : getTranslation(setting, "Common", "Create")}
                <ReactSVG className="icon" src="/icons/submit.svg" />
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default DriverForm;
